// Shared-element "flight" animation between the Peeps grid and the Rooms view.
// A card's DOM rect is captured just before the view switches away from it,
// then the destination element FLIPs in from that captured rect to its own
// resting position. No cloning — the destination element itself animates.

export const pendingFlightRects = new Map();

export const FLIGHT_DURATION = 420;

export const captureFlightRects = ( root, identities ) => {
    if ( !root ) {
        return;
    }

    identities.forEach( ( identity ) => {
        const el = root.querySelector( `[data-identity="${ identity }"]` );

        if ( el ) {
            pendingFlightRects.set( identity, el.getBoundingClientRect() );
        }
    } );
};

export const flipFromPending = ( root ) => {
    if ( !root ) {
        return;
    }

    root.querySelectorAll( '[data-identity]' ).forEach( ( el ) => {
        const identity = el.getAttribute( 'data-identity' );
        const oldRect = pendingFlightRects.get( identity );

        if ( !oldRect || oldRect.width === 0 ) {
            return;
        }

        const newRect = el.getBoundingClientRect();

        const deltaX = ( oldRect.left + oldRect.width / 2 ) - ( newRect.left + newRect.width / 2 );
        const deltaY = ( oldRect.top + oldRect.height / 2 ) - ( newRect.top + newRect.height / 2 );
        const scale = newRect.width > 0 ? oldRect.width / newRect.width : 1;

        el.style.transition = 'none';
        el.style.transform = `translate(${ deltaX }px, ${ deltaY }px) scale(${ scale })`;

        requestAnimationFrame( () => {
            el.style.transition = `transform ${ FLIGHT_DURATION }ms cubic-bezier(0.22, 1, 0.36, 1)`;
            el.style.transform = '';
        } );

        pendingFlightRects.delete( identity );
    } );
};
